import React from 'react';
import { Box, SimpleGrid, Flex, Image, Container, Card, Link, List } from '@chakra-ui/react';

import HomeLayout from '../../components/layouts/homelayout';
import ImpactReporth2 from '../../components/sections/impactreport/impact-h2';

import CtaShort from '../../components/sections/ctashort';
//import CarouselStories from '../../components/sections/carouselstories';
import GridCard from '../../components/sections/gridcard';

// Get the logos
import columbiaLogo from '../../components/ui/brandlogos/columbia_logo.png';
import sorelLogo from '../../components/ui/brandlogos/sorel_logo.png';
import mhwLogo from '../../components/ui/brandlogos/mhw_logo.png';
import pranaLogo from '../../components/ui/brandlogos/prana_logo.png';

// Get the background images
import mhwBkgImg from '../../components/ui/corporateresponsibility/impact/mhw_impact-report_home.jpg';
import pranaBkgImg from '../../components/ui/corporateresponsibility/impact/prana_impact-report_home.jpg';
import columbiaBkgImg from '../../components/ui/corporateresponsibility/impact/columbia_impact-report_home.jpg';
import sorelBkgImg from '../../components/ui/corporateresponsibility/impact/sorel_impact-report_home.jpg';

// Impact Report images
import ir2015 from '../../components/ui/corporateresponsibility/impact/CSC_SR_2015_cover.jpg';
import ir2016 from '../../components/ui/corporateresponsibility/2016_impact-report_cover.png';
import ir2017 from '../../components/ui/corporateresponsibility/2017_impact-report_cover.png';
import ir2018 from '../../components/ui/corporateresponsibility/2018_impact-report_cover.png';
import ir2019 from '../../components/ui/corporateresponsibility/2019_impact-report_cover.png';
import ir2020 from '../../components/ui/corporateresponsibility/2020_impact-report_cover.png';
import ir2021 from '../../components/ui/corporateresponsibility/2021_impact-report_cover.png';
import ir2022 from '../../components/ui/corporateresponsibility/2022_impact-report_cover.png';
import ir2023 from '../../components/ui/corporateresponsibility/impact/2023_impact-report_cover_16x9.png';

// Highlights
import empoweringPeopleImg from '../../components/ui/corporateresponsibility/impact/2024-impact-report/about/empowering_people_highlights.jpg';
import sustainingPlacesImg from '../../components/ui/corporateresponsibility/impact/2024-impact-report/about/sustaining_places_highlights_1.jpg';
import responsiblePracticesImg from '../../components/ui/corporateresponsibility/impact/2024-impact-report/about/responsible_practices_highlights.jpg';

// Other image assets
import impactBadge from '../../components/ui/corporateresponsibility/impact/impact_report_badge.svg';

export default function Impact() {

    return (
        <HomeLayout align="left">
            <title>Corporate Responsibility - Impact Report</title>
            <meta name="description" content="Columbia Sportswear Company's Impact Report demonstrates our commitment to ensuring the sustainability of our business and the planet." />
            <Box className='page-banner' w="full"
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                >
                <SimpleGrid columns={2}
                    gap={1}
                    padding={{ base: 0, md: 10 }}
                >
                     <Flex 
                        maxW="100%"
                        justify="flex-start"
                        align="flex-end"
                        bgImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)) , url(${columbiaBkgImg})`}
                        bgSize="cover"
                        bgRepeat="no-repeat"
                        pos={'relative'}
                        pb={'8px'}
                        pl={'8px'}
                        minH={'clamp(200px, 50vw, 400px)'}
                    >
                        <Image
                            src={columbiaLogo}
                            alt={'Columbia Logo'}
                            width={{ base: '50%', md: '40%' }}
                        />
                    </Flex>

                    <Flex 
                        maxW="100%"
                        justify="flex-end"
                        align="end"
                        bgImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)) , url(${sorelBkgImg})`}
                        bgSize="cover"
                        bgRepeat="no-repeat"
                        pb={'8px'}
                        pr={'8px'}
                    >
                        <Image
                            src={sorelLogo}
                            alt={'Sorel Logo'}
                            width={{ base: '30%', md: '25%' }}
                        />
                    </Flex>

                    <Flex 
                        maxW="100%"
                        //minH={{base: '150px', md: '325px'}}
                        justify="flex-start"
                        align="flex-end"
                        bgImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)) , url(${mhwBkgImg})`}
                        bgSize="cover"
                        bgRepeat="no-repeat"
                        //minH={'clamp(200px, 50vw, 633px)'}
                        minH={'clamp(200px, 50vw, 400px)'}
                        pb={'8px'}
                        pl={'8px'}
                    >
                        <Image
                            src={mhwLogo}
                            alt={'Mountain Hardwear Logo'}
                            width={{ base: '40%', md: '25%' }}
                        />
                    </Flex>

                    <Flex 
                        maxW="100%"
                        //minH={{base: '150px', md: '325px'}}
                        justify="flex-end"
                        align="end"
                        bgImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)) , url(${pranaBkgImg})`}
                        bgSize="cover"
                        bgRepeat="no-repeat"
                        pb={'8px'}
                        pr={'8px'}
                        //minH={'clamp(200px, 50vw, 633px)'}
                    >
                        <Image
                            src={pranaLogo}
                            alt={'prAna Logo'}
                            width={{ base: '40%', md: '26%' }}
                        />
                    </Flex>
                </SimpleGrid>
                <Image
                    src={impactBadge}
                    alt={'ESG Badge'}
                    pos={'absolute'}
                    w={{ base: '35%', md: '25%'}}
                />
            </Box>

            <section id='report-highlights-section'>
                <div className='container flow'>
                    <ImpactReporth2>2024 Highlights</ImpactReporth2>
                    <Box
                        marginTop={6}
                    >
                        <SimpleGrid
                            columns={{ base: 1, sm: 2, md: 3}}
                            gap={{ base : 8, md: 4 }}
                        >
                            <Box>
                                <Box 
                                    className='highlights-image'
                                    display={'flex'}
                                    justifyContent={'center'}
                                >
                                    <Image src={empoweringPeopleImg} borderRadius={'50%'} width={'75%'} />
                                </Box>
                                <Box 
                                    className='highlights-text'
                                    padding={4}
                                    mt={1}    
                                >
                                    <div>
                                        <h4>Empowering People</h4>
                                    </div>
                                    
                                    <List.Root mt={3} fontSize={'var(--step--1)'}>
                                        <List.Item>
                                            As of 2024, we’ve exceeded 80% of our Planet Water goal of providing access to clean water for 100,000 people per day.
                                        </List.Item>
                                        <List.Item>
                                            Employees contributed over 6,100 volunteer hours. 
                                        </List.Item>
                                        <List.Item>
                                            Mountain Hardwear was named Corporate Partner of the Year by Leave No Trace.
                                        </List.Item>
                                        <List.Item>
                                            The myWellbeing program reimbursed more than 1,300 unique requests for a variety of employee wellness activities.
                                        </List.Item>
                                    </List.Root>
                                </Box>
                            </Box>
                            <Box>
                                <Box 
                                    className='highlights-image'
                                    display={'flex'}
                                    justifyContent={'center'}
                                >
                                    <Image src={sustainingPlacesImg} borderRadius={'50%'} width={'75%'} />
                                </Box>
                                <Box 
                                    className='highlights-text'
                                    padding={4}    
                                >
                                    <div>
                                        <h4>Sustaining Places</h4>
                                    </div>
                                    <List.Root mt={3} fontSize={'var(--step--1)'}>
                                        <List.Item>
                                            Absolute energy consumption, 2022 versus 2024, at our Oregon distribution center and headquarters has declined by over 900,000 kilowatt hours and nearly 67,000 therms.<span className='fn-link' id="fn1"><a href="/corporate-responsibility/impact/2024#fn1_content"><sup>1</sup></a></span>
                                        </List.Item>
                                        <List.Item>
                                            Chinese Taipei office began a program to procure 100% Renewable Energy Certificates (RECs) to account for all grid energy consumption.
                                        </List.Item>
                                        <List.Item>
                                            Global corrugated outer cartons and inner boxes used for product packaging contained a minimum of 95% recycled content in 2024.
                                        </List.Item>
                                    </List.Root>
                                </Box>
                            </Box>
                            <Box>
                                <Box 
                                    className='highlights-image'
                                    display={'flex'}
                                    justifyContent={'center'}
                                >
                                    <Image src={responsiblePracticesImg} borderRadius={'50%'} width={'75%'} />
                                </Box>
                                <Box 
                                    className='highlights-text'
                                    padding={4}    
                                >
                                    <div>
                                        <h4>Responsible Practices</h4>
                                    </div>
                                    
                                    <List.Root mt={3} fontSize={'var(--step--1)'} >
                                        <List.Item>
                                            In July 2024, our internal Ethics & Compliance awareness month highlighted our Compliance Line to further encourage a speak-up culture.
                                        </List.Item>
                                        <List.Item>
                                            In partnership with all other RISE industry supporters in 2024, RISE reached over 425 workplaces, totaling more than 375,000 workers, over 65% of whom identify as women.
                                        </List.Item>
                                        <List.Item>
                                            In 2024, we worked with 330 finished good vendors, of which 87% completed at least one audit or assessment during the year.
                                        </List.Item>
                                    </List.Root>
                                </Box>
                            </Box>

                            </SimpleGrid>
                        </Box>
                </div>
            </section>
            <Box>
                <CtaShort 
                    button_text={'Read the 2024 Impact Report'}
                    button_url={'/corporate-responsibility/impact/2024'}
                    backgroundColor={'var(--columbia-blue);'}
                    style={{ '--gradient-color': 'var(--columbia-blue)' }}
                />
            </Box>
            <Box 
                as='section'
                mt={6}
            >
                <Container maxW='7xl' my={14} className='flow'>
                    <h2>Historic Impact Reports</h2>
                    <SimpleGrid
                        align={'center'}
                        columns={{ base: 1, md: 2, lg: 3 }}
                        //spacing={4}
                        py={4}
                        gap={8}
                    >
                        <Card.Root variant='subtle'>
                            <Card.Body>
                                <GridCard
                                    title="2023 Report"
                                    href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2023_Columbia_Impact_Report.pdf"
                                    backgroundImage={ir2023}
                                    //type='is-medium three-column'
                                />
                                <Link display='inline-block' mt={3} href='https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2023_CSC_SASB.pdf' target="_blank" rel="noopener noreferrer">
                                    2023 SASB Summary
                                </Link>
                            </Card.Body>
                        </Card.Root>

                        <Card.Root variant='subtle'>
                            <Card.Body>
                                <GridCard
                                    title="2022 Report"
                                    href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2022_Columbia_Impact_Report.pdf"
                                    backgroundImage={ir2022}
                                    //type='is-medium three-column'
                                />
                                <Link display='inline-block' mt={3} href='https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2022_CSC_SASB.pdf' target="_blank" rel="noopener noreferrer">
                                    2022 SASB Summary
                                </Link>
                            </Card.Body>
                        </Card.Root>

                        <Card.Root variant='subtle'>
                            <Card.Body>
                            <GridCard 
                                title="2021 Report"
                                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2021_Columbia_Corp_Resp_Report.pdf"
                                backgroundImage={ir2021}
                                //type='is-medium three-column'
                            />
                            <Link display='inline-block' mt={3} href='https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2021_CSC_SASB.pdf' target="_blank" rel="noopener noreferrer">
                                2021 SASB Summary
                            </Link>
                            </Card.Body>
                        </Card.Root>
                        <Card.Root variant='subtle'>
                            <Card.Body>
                            <GridCard
                                title="2020 Report"
                                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2020_Columbia_Corp_Resp_Report.pdf"
                                backgroundImage={ir2020}
                                //type='is-medium three-column'
                            />
                            <Link display='inline-block' mt={3} href='https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2020_CSC_SASB.pdf' target="_blank" rel="noopener noreferrer">
                                2020 SASB Summary
                            </Link>
                            </Card.Body>
                        </Card.Root>
                        <Card.Root variant='subtle'>
                            <Card.Body>
                            <GridCard
                                title="2019 Report"
                                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2019_Columbia_Corp_Resp_Report.pdf"
                                backgroundImage={ir2019}
                                //type='is-medium three-column'
                            />
                            </Card.Body>
                        </Card.Root>
                        <Card.Root variant='subtle'>
                            <Card.Body>
                            <GridCard
                                title="2018 Report"
                                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2018_Columbia_Corp_Resp_Report.pdf"
                                backgroundImage={ir2018}
                                //type='is-medium three-column'
                            />
                            </Card.Body>
                        </Card.Root>
                        <Card.Root variant='subtle'>
                            <Card.Body>
                            <GridCard
                                title="2017 Report"
                                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2017_Columbia_Corp_Resp_Report.pdf"
                                backgroundImage={ir2017}
                                //type='is-medium three-column'
                            />
                            </Card.Body>
                        </Card.Root>
                        <Card.Root variant='subtle'>
                            <Card.Body>
                            <GridCard
                                title="2016 Report"
                                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2016_Columbia_Corp_Resp_Report.pdf"
                                backgroundImage={ir2016}
                                //type='is-medium three-column'
                            />
                            </Card.Body>
                        </Card.Root>
                        <Card.Root variant='subtle'>
                            <Card.Body>
                            <GridCard
                                title="2015 Report"
                                href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2015_Columbia_Corp_Resp_Report.pdf"
                                backgroundImage={ir2015}
                                //type='is-medium three-column'
                            />
                            </Card.Body>
                        </Card.Root>
                    </SimpleGrid>
                </Container>
            </Box>
        </HomeLayout>
    );
}